// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"b1a53965","333":"1d95fab1"}[chunkId] + ".chunk.css";
};